import { ViewDensity, ViewType } from "@common/types/views/views";
import {
    HistoryClassDetailsColumn,
    HistoryClassDetailsView,
} from "./historyClassDetailsView";

export const defaultHistoryClassDetailsView: HistoryClassDetailsView = {
    type: ViewType.HISTORY_UPDATED_TRANSACTION,
    columns: [
        { id: HistoryClassDetailsColumn.TIME },
        { id: HistoryClassDetailsColumn.CLASS_NAME },
    ],
    filters: {},
    options: {
        selection: true,
        density: ViewDensity.MD,
    },
};

export const createDefaultHistoryClassUpdateView =
    (): HistoryClassDetailsView => ({
        type: ViewType.HISTORY_UPDATED_TRANSACTION,
        columns: [
            { id: HistoryClassDetailsColumn.TIME },
            { id: HistoryClassDetailsColumn.CLASS_NAME },
            { id: HistoryClassDetailsColumn.PREVIOUS },
            { id: HistoryClassDetailsColumn.MODIFIED },
        ],
        filters: {},
        options: {
            selection: true,
            density: ViewDensity.MD,
        },
    });
